import React from 'react';

/** Blueprint & Reputation emblem — user-provided asset (mask + currentColor). */
export default function PersonalHubFactionReputationIcon({ className = '' }) {
  return (
    <span
      className={['personal-hub-rail__factions-reputations-icon', className]
        .filter(Boolean)
        .join(' ')}
      aria-hidden="true"
    />
  );
}
